import { Link } from "react-router-dom";
import { Container, Section, PageHero } from "../components/common";
import { useServices, useBlog } from "../lib/api";
import { useSeo, breadcrumbLd } from "../lib/seo";

const MAIN = [
 ["Home", "/"], ["About", "/about"], ["Services", "/services"],
 ["Blog", "/blog"], ["FAQ", "/faq"], ["Reviews", "/reviews"], ["Warranty", "/warranty"],
 ["Financing", "/financing"], ["Contact", "/contact"], ["Schedule Appointment", "/schedule-appointment"],
 ["Privacy Policy", "/privacy-policy"], ["Terms of Service", "/terms"],
];

export default function SitemapPage() {
 const { data: services = [] } = useServices();
 const { data: posts = [] } = useBlog();
 useSeo({ title: "Sitemap | RPM Auto Repair", description: "Full sitemap of RPM Auto Repair, services, service areas, blog and more.", path: "/sitemap",
 jsonLd: [breadcrumbLd([{ name: "Home", path: "/" }, { name: "Sitemap", path: "/sitemap" }])] });
 const Col = ({ title, links }) => (
 <div>
 <h2 className="font-display text-xl text-primary">{title}</h2>
 <ul className="mt-4 space-y-2">
 {links.map(([label, to]) => (
 <li key={to}><Link to={to} className="text-sm text-muted-foreground hover:text-white">{label}</Link></li>
 ))}
 </ul>
 </div>
 );
 return (
 <>
 <PageHero title="Sitemap" subtitle="Every page on our website, all in one place."
 crumbs={[{ name: "Home", path: "/" }, { name: "Sitemap", path: "/sitemap" }]} />
 <Section>
 <Container className="grid gap-10 sm:grid-cols-2 lg:grid-cols-3">
 <Col title="Main Pages" links={MAIN} />
 <Col title="Services" links={services.map((s) => [s.name, `/services/${s.slug}`])} />
 <Col title="Blog Articles" links={posts.map((p) => [p.title, `/blog/${p.slug}`])} />
 </Container>
 </Section>
 </>
 );
}
